import setupDeprecationWorkflow from 'ember-cli-deprecation-workflow';

setupDeprecationWorkflow({
  workflow: [
    {
      handler: 'silence',
      matchId: 'deprecate-import-libraries-from-ember',
    },
    {
      handler: 'silence',
      matchId: 'deprecate-import-test-from-ember',
    },
    {
      handler: 'silence',
      matchId: 'importing-inject-from-ember-service',
    },
    {
      handler: 'silence',
      matchId: 'deprecate-import---loader-from-ember',
    },
    {
      handler: 'silence',
      matchId: 'deprecate-import-testing-from-ember',
    },
  ],
});
